import React from 'react'
import { Grid, GridProps, IconButton, Typography } from '@mui/material'
import {
  PaginationNextArrow,
  PaginationPreviousArrow,
  PrevSkipArrowPagination,
} from 'components/SVG'
import NextSkipArrowPagination from 'components/SVG/NextSkipArrowPagination'

type PaginationProps = {
  itemsPerPage?: number
  dataCount?: number
  currentPage: number
  setCurrentPage: (page: number) => void
  gridProps?: GridProps
}

function Pagination({
  itemsPerPage = 6,
  dataCount = 0,
  currentPage,
  setCurrentPage,
  gridProps = {},
}: PaginationProps) {
  const totalPages = Math.ceil(dataCount / itemsPerPage)

  const handlePageChange = (page: number) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page)
    }
  }

  return (
    <Grid
      container
      item
      alignItems='center'
      justifyContent='flex-end'
      xs={12}
      marginTop={-1}
      paddingBottom={2}
      {...gridProps}
    >
      <IconButton onClick={() => handlePageChange(1)}>
        <PrevSkipArrowPagination />
      </IconButton>
      <IconButton onClick={() => handlePageChange(currentPage - 1)}>
        <PaginationPreviousArrow />
      </IconButton>
      <Typography
        sx={{ px: 1 }}
      >{`Page ${currentPage} of ${totalPages}`}</Typography>
      <IconButton onClick={() => handlePageChange(currentPage + 1)}>
        <PaginationNextArrow />
      </IconButton>
      <IconButton onClick={() => handlePageChange(totalPages)}>
        <NextSkipArrowPagination />
      </IconButton>
    </Grid>
  )
}

export default Pagination
